var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.889 17.6831V20.1117C15.889 21.7071 14.5955 23.0006 13.0001 23.0006H4.33335C2.73786 23.0006 1.44445 21.7071 1.44445 20.1117V4.94492C1.44445 3.34943 2.73785 2.05602 4.33335 2.05602H13C13.7078 2.05602 14.3561 2.31053 14.8584 2.73302C15.2891 2.53688 15.8334 2.37536 16.4761 2.35697C15.6861 1.29759 14.4232 0.611572 13 0.611572H4.33335C1.94011 0.611572 0 2.55168 0 4.94492V20.1117C0 22.5049 1.94011 24.445 4.33335 24.445H13.0001C15.3933 24.445 17.3334 22.5049 17.3334 20.1117V16.2885L15.889 17.6831Z",
    fill: "#5D86DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.166 7.83384L7.6451 15.4796C7.37421 15.7505 7.22203 16.1179 7.22203 16.501C7.22203 16.8841 7.37421 17.2515 7.6451 17.5224C7.91599 17.7932 8.28339 17.9454 8.66648 17.9454C9.04957 17.9454 9.41698 17.7932 9.68786 17.5224L18.6532 8.43215C18.9215 8.16389 19.1342 7.84542 19.2794 7.49492C19.4246 7.14443 19.4993 6.76876 19.4993 6.38939C19.4993 6.01001 19.4246 5.63435 19.2794 5.28385C19.1342 4.93336 18.9214 4.61489 18.6532 4.34663C18.3849 4.07837 18.0665 3.86557 17.716 3.72039C17.3655 3.57521 16.9898 3.50049 16.6104 3.50049C16.2311 3.50049 15.8554 3.57521 15.5049 3.72039C15.1544 3.86557 14.8359 4.07837 14.5677 4.34663L5.60234 13.4368C4.78968 14.2495 4.33313 15.3517 4.33313 16.501C4.33313 17.6503 4.78968 18.7525 5.60234 19.5651C6.415 20.3778 7.51721 20.8343 8.66648 20.8343C9.81576 20.8343 10.918 20.3778 11.7306 19.5651L19.1382 12.1672",
    stroke: "#5D86DA",
    strokeWidth: 1.44445,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment-icon.891c0016.svg";
export { ForwardRef as ReactComponent };